var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('inline-svg',{attrs:{"src":_vm.loading_icon,"width":"80","height":"80"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }